import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@hooks/useStore';
import CloseIcon from '@icons/close_icon.svg?component';
import { MyFC } from '@/types/common';
import { IPopupProps } from './types';
import { BASIC_POPUP_WIDTH } from './constants';

const Popup: MyFC<IPopupProps> = ({
  children,
  width = BASIC_POPUP_WIDTH,
  showClose = false,
  available = true,
  onClose,
}) => {
  const {
    popupStore: { open, closePopup, popupName },
  } = useStore();

  const [lastPopup, setLastPopup] = useState<string | null>(null);

  useEffect(() => {
    if (!open && lastPopup) {
      if (onClose) onClose();
    } else {
      setLastPopup(popupName);
    }
  }, [open, popupName, lastPopup]);

  return (
    <>
      {open && children && available && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
          <div
            className="bg-white p-[32px] rounded-[16px] shadow-lg relative mobile-popup"
            style={{ width }}
          >
            {showClose && (
              <button className="absolute top-[32px] right-[32px]" onClick={() => closePopup()}>
                <CloseIcon width={16} height={16} />
              </button>
            )}
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default observer(Popup);
